import React from 'react';
import { css } from 'emotion';
import ProcessWizardPage from 'components/page/process/wizard/ProcessWizardPage';
import RunCodeForm from 'components/page/process/RunCodeForm';

export default class RunPage extends ProcessWizardPage {
    static defaultProps = {
        title: 'Run Data Consolidator',
        description: 'Run the data consolidator to consolidate all the datastreams defined by this process into a single output file.'
    };

    renderFormWithProcess() {
        return (
            <div className={css`flex: 1`}>
                <RunCodeForm
                    {...this.props}
                    wizardMode
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/page/process/wizard/RunPage.js